import { Component, inject, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LoggedInUserService } from '../../../services/common/logged-in-user.service';
import { ILoggedInUser } from '../../../interfaces/common/loggedInUser';
import { CommonModule } from '@angular/common';
import { RequestAndLineTypeService } from '../../services/request-and-line-types.service';
import { ILineType } from '../../models/line-type.model';
import { LineTypeAccount } from '../../models/line-type-account.model';
import { ManageLineTypeModel } from '../../models/manage-line-type.model';
import { SearchRequestService } from '../../../manage-request/services/search-request.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { SharedService } from '../../../services/common/shared.service';
import { CodeModel } from '../../models/code.model';
import { EmployeeCategoriesService } from '../../services/employee-categories.service';
import { promptTypes } from '../../administration.const';

@Component({
  selector: 'app-manage-line-type',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule],
  templateUrl: './manage-line-type.component.html',
  styleUrl: './manage-line-type.component.scss'
})
export class ManageLineTypeComponent {
title: string  = "";
  buttonName:string = "";
  formLineType: FormGroup;
  formLineTypeAccount: FormGroup;
  user: ILoggedInUser;
  isAdmin: boolean = false;
  lineTypeModel: ILineType;
  information: string = "";
  validationMessage: string = "";
  lintTypeAccounts: LineTypeAccount[];
  isLoading: boolean = false;

  allAccount: LineTypeAccount = new LineTypeAccount();
  opexAccount: LineTypeAccount = new LineTypeAccount();
  afeAccount: LineTypeAccount = new LineTypeAccount();
  specificAccounts: LineTypeAccount[] = [];  
  specificAccountsNumber: number = 0;
  specificAccountsInfo: string = "";
  isAllCostAdded: boolean = false;
  isRestCostAdded: boolean = false;
  
  employeeTypeCodes: CodeModel[];
  promptTypesLocal: CodeModel[];
  propmptTypeSelected: string = '';
  
  searchRequestService: SearchRequestService = inject(SearchRequestService);
  requestTypesList = toSignal(this.searchRequestService.getAllRequestTypes(), { rejectErrors: true });

  employeeCategoriesService: EmployeeCategoriesService = inject(EmployeeCategoriesService);
  employeeCategoriesList = toSignal(this.employeeCategoriesService.searchEmployeeCategories(), { rejectErrors: true });
 

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { requestType: string, lineType: string, isEdit: boolean },    
    public dialogRef: MatDialogRef<ManageLineTypeComponent>,
    private fb: FormBuilder,    
    private userService: LoggedInUserService,    
    private requestAndLineTypeService: RequestAndLineTypeService, 
    private sharedService: SharedService,  
  ) {}

  ngOnInit(): void {     
    this.promptTypesLocal = promptTypes
    
    this.formLineType = this.fb.group({
      type: new FormControl(''),
      description: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
      forEmployeeType: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
      forEmployeeCategory: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
      forMode: new FormControl('D', ),
      gO165Required: new FormControl(false),
      rateDecimal: new FormControl(0, { nonNullable: true, validators: [Validators.required] }),
      limitDecimal: new FormControl(0, { nonNullable: true, validators: [Validators.required] }),
      requestType: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
      confidential: new FormControl(false),
      recurringBenefit: new FormControl(false),
      cycle: new FormControl(0, { nonNullable: true, validators: [Validators.required] }),
      promptType: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
      promptText1: new FormControl(''),
      promptText2: new FormControl(''),
      promptText3: new FormControl(''),
      rateBenefitBased: new FormControl(false),
      enteredByName: new FormControl('' ),
      dateEntered: new FormControl(new Date()),
      updatedByName: new FormControl(''),
      dateUpdated: new FormControl(new Date(),),
      enteredByEmail: new FormControl(''),
      updatedByEmail: new FormControl('')
    });


    this.formLineTypeAccount = this.fb.group({  
      allCost: new FormControl(''),
      allObj: new FormControl(''),
      allSub: new FormControl(''),
      afeObj: new FormControl(''),
      afeSub: new FormControl(''),
      opexObj: new FormControl(''),
      opexSub: new FormControl(''),
    })

    this.userService.currentUser$.subscribe(data => {
      this.user = data;
      if(this.user != null && this.user.adminRight){
        this.isLoading = true;
        this.isAdmin = this.user.adminRight;
        if(this.data.isEdit){
          this.geRequestAndLineType()
        }
      }      
    })

    this.getEmployeeTypes();    

    if(this.data.isEdit){
      this.buttonName = "Update";
      this.title = "Edit Line Type";           
    } else {
      this.buttonName = "Add";
      this.title = "New Line Type"; 
    }      
  }   

  geRequestAndLineType(){
    this.requestAndLineTypeService.getLineType(this.data.lineType).subscribe(data => {
      this.lineTypeModel = data;
      this.patchValues()
    });

    this.requestAndLineTypeService.getLineTypeAccounts(this.data.requestType, this.data.lineType).subscribe(data => {  
      this.lintTypeAccounts = data;
      this.allAccount = this.lintTypeAccounts.find(x => x.entryType.trim() == '') || this.getDefaultObject('');
      this.opexAccount = this.lintTypeAccounts.find(x => x.entryType == 'O')|| this.getDefaultObject('O');
      this.afeAccount = this.lintTypeAccounts.find(x => x.entryType == 'A')|| this.getDefaultObject('A');
      this.specificAccountsNumber = this.lintTypeAccounts.filter(x => x.entryType == 'S').length;
      var specificAccountsTemp = this.lintTypeAccounts.filter(x => x.entryType == 'S');
      this.creatAadditionalFormLineTypeAccount(specificAccountsTemp);
      this.patchlineTypeAccoutValues(); 
      this.onRestCostChange()
      this.onAllCostChange() 
      this.isLoading = false; 
    });
  }

  getEmployeeTypes(){
    this.sharedService.getCodes('EmployeeType').subscribe({
      next: (data) => {
        this.employeeTypeCodes = data;
        if (this.data.isEdit) {          
        }
        this.isLoading = false;
      }});
  }

  creatAadditionalFormLineTypeAccount(accounts: LineTypeAccount[]){  
    accounts.forEach((account, index) => {
        this.formLineTypeAccount.addControl(`specificCost${index + 1}`, new FormControl(''));
        this.formLineTypeAccount.addControl(`specificObj${index + 1}`, new FormControl(''));
        this.formLineTypeAccount.addControl(`specificSub${index + 1}`, new FormControl(''));
        this.formLineTypeAccount.addControl(`line${index + 1}`, new FormControl(''));
    });
    this.specificAccounts = accounts;
  }
  
  getDefaultObject(entryType: string):LineTypeAccount{
    return{
      lineType: this.data.lineType,
      requestType: this.data.requestType,
      entryType: entryType,
      line: 0,
      mcu: '',
      obj: '',
      sub: ''
    }
  };

  patchlineTypeAccoutValues() {
    this.formLineTypeAccount.patchValue({
      allCost: this.allAccount ? this.allAccount.mcu : "",
      allObj: this.allAccount ? this.allAccount.obj : "",
      allSub: this.allAccount ? this.allAccount.sub : "",

      afeObj: this.afeAccount ? this.afeAccount.obj : "",
      afeSub: this.afeAccount ? this.afeAccount.sub : "",

      opexObj: this.opexAccount ? this.opexAccount.obj : "",
      opexSub: this.opexAccount ? this.opexAccount.sub : "",
      });

      this.specificAccounts.forEach((account, index) => {
        this.formLineTypeAccount.patchValue({
        [`specificCost${index + 1}`]: account.mcu ? account.mcu : "",
        [`specificObj${index + 1}`]: account.obj ? account.obj : "",
        [`specificSub${index + 1}`]: account.sub ? account.sub : "",
        [`line${index + 1}`]: index + 1,
        });
      })      
  }

  patchValues() {
    this.propmptTypeSelected = this.lineTypeModel.promptType;
    this.formLineType.patchValue({
      type: this.lineTypeModel.type,
      description: this.lineTypeModel.description,
      forEmployeeType: this.lineTypeModel.forEmployeeType,
      forEmployeeCategory: this.lineTypeModel.forEmployeeCategory,
      forMode: this.lineTypeModel.forMode,
      gO165Required: this.lineTypeModel.gO165Required,
      rateDecimal: this.lineTypeModel.rateDecimal,
      limitDecimal: this.lineTypeModel.limitDecimal,
      requestType: this.lineTypeModel.requestType,
      confidential: this.lineTypeModel.confidential,
      recurringBenefit: this.lineTypeModel.recurringBenefit,
      cycle: this.lineTypeModel.cycle,
      promptType: this.lineTypeModel.promptType,
      promptText1: this.lineTypeModel.promptText1,
      promptText2: this.lineTypeModel.promptText2,
      promptText3: this.lineTypeModel.promptText3,
      rateBenefitBased: this.lineTypeModel.rateBenefitBased,
      enteredByName: this.lineTypeModel.enteredByName,
      dateEntered: this.lineTypeModel.dateEntered,
      updatedByName: this.lineTypeModel.updatedByName,
      dateUpdated: this.lineTypeModel.dateUpdated,
      enteredByEmail: this.lineTypeModel.enteredByEmail,
      updatedByEmail: this.lineTypeModel.updatedByEmail
    });
  }

  getformValues(): ILineType{
    return {
      rate: "",
      limit: "",
      type: this.formLineType.get('type').value,
      description: this.formLineType.get('description').value,
      forEmployeeType: this.formLineType.get('forEmployeeType').value,
      forEmployeeCategory: this.formLineType.get('forEmployeeCategory').value,
      forMode: this.formLineType.get('forMode').value,
      gO165Required: this.formLineType.get('gO165Required').value,
      rateDecimal: this.formLineType.get('rateDecimal').value,
      limitDecimal: this.formLineType.get('limitDecimal').value,
      requestType: this.formLineType.get('requestType').value,
      confidential: this.formLineType.get('confidential').value,
      recurringBenefit: this.formLineType.get('recurringBenefit').value,
      cycle: this.formLineType.get('cycle').value,
      promptType: this.formLineType.get('promptType').value,
      promptText1: this.formLineType.get('promptText1').value,
      promptText2: this.formLineType.get('promptText2').value,
      promptText3: this.formLineType.get('promptText3').value,
      rateBenefitBased: this.formLineType.get('rateBenefitBased').value,
      enteredByName: this.data.isEdit ? this.formLineType.get('enteredByName').value : this.user.userName,
      dateEntered: this.data.isEdit ? this.formLineType.get('dateEntered').value : new Date(),
      enteredByEmail: this.data.isEdit ? this.formLineType.get('enteredByEmail').value : this.user.userEmail,
      updatedByName: this.user.userName,
      dateUpdated: new Date(),      
      updatedByEmail: this.user.userEmail
    };
  }

  getManageLineTypeAccountValues(): ManageLineTypeModel{
    return {
      lineTypeModel: this.getformValues(),
      lineTypeAccounts: this.getFormLineTypeAccountValues()
    };
  }

  getFormLineTypeAccountValues(): LineTypeAccount[]{    
    this.allAccount.mcu = this.formLineTypeAccount.get('allCost').value ? this.formLineTypeAccount.get('allCost').value : "";
    this.allAccount.obj = this.formLineTypeAccount.get('allObj').value ? this.formLineTypeAccount.get('allObj').value : "";
    this.allAccount.sub = this.formLineTypeAccount.get('allSub').value ? this.formLineTypeAccount.get('allSub').value : "";
    this.allAccount.requestType = this.data.isEdit ? this.data.requestType : this.formLineType.get('requestType').value;
    this.allAccount.lineType = this.data.lineType;
    this.allAccount.entryType = ''; 
    this.allAccount.line = 0;
    this.allAccount.enteredByEmail = this.data.isEdit ? this.formLineType.get('enteredByEmail').value : this.user.userEmail;
    this.allAccount.enteredByName = this.data.isEdit ? this.formLineType.get('enteredByName').value : this.user.userName;
    this.allAccount.dateEntered = this.data.isEdit ? new Date(this.formLineType.get('dateEntered').value) : new Date();
    this.allAccount.updatedByName = this.user.userName;
    this.allAccount.dateUpdated = new Date();
    this.allAccount.updatedByEmail = this.user.userEmail;

    this.afeAccount.obj = this.formLineTypeAccount.get('afeObj').value ? this.formLineTypeAccount.get('afeObj').value : "";
    this.afeAccount.sub = this.formLineTypeAccount.get('afeSub').value ? this.formLineTypeAccount.get('afeSub').value : "";
    this.afeAccount.requestType = this.data.isEdit ? this.data.requestType: this.formLineType.get('requestType').value;
    this.afeAccount.lineType = this.data.lineType;
    this.afeAccount.entryType = "A"; 
    this.afeAccount.line = 0;
    this.afeAccount.enteredByEmail = this.data.isEdit ? this.formLineType.get('enteredByEmail').value : this.user.userEmail;
    this.afeAccount.enteredByName = this.data.isEdit ? this.formLineType.get('enteredByName').value : this.user.userName;
    this.afeAccount.dateEntered = this.data.isEdit ? new Date(this.formLineType.get('dateEntered').value) : new Date();
    this.afeAccount.updatedByName = this.user.userName;
    this.afeAccount.dateUpdated = new Date();
    this.afeAccount.updatedByEmail = this.user.userEmail;

    this.opexAccount.obj = this.formLineTypeAccount.get('opexObj').value ? this.formLineTypeAccount.get('opexObj').value : "";
    this.opexAccount.sub = this.formLineTypeAccount.get('opexSub').value ? this.formLineTypeAccount.get('opexSub').value : "";
    this.opexAccount.requestType = this.data.isEdit ? this.data.requestType : this.formLineType.get('requestType').value;
    this.opexAccount.lineType = this.data.lineType;
    this.opexAccount.entryType = "O"; 
    this.opexAccount.line = 0;
    this.opexAccount.enteredByEmail = this.data.isEdit ? this.formLineType.get('enteredByEmail').value : this.user.userEmail;
    this.opexAccount.enteredByName = this.data.isEdit ? this.formLineType.get('enteredByName').value : this.user.userName;
    this.opexAccount.dateEntered = this.data.isEdit ? new Date(this.formLineType.get('dateEntered').value) : new Date();
    this.opexAccount.updatedByName = this.user.userName;
    this.opexAccount.dateUpdated = new Date();
    this.opexAccount.updatedByEmail = this.user.userEmail;

    this.specificAccounts.forEach((account, index) => {
      const lineIndex = index + 1;      
      const mcu = this.formLineTypeAccount.get(`specificCost${lineIndex}`).value ? this.formLineTypeAccount.get(`specificCost${lineIndex}`).value : "";
      const obj = this.formLineTypeAccount.get(`specificObj${lineIndex}`).value ? this.formLineTypeAccount.get(`specificObj${lineIndex}`).value : "";
      const sub = this.formLineTypeAccount.get(`specificSub${lineIndex}`).value ? this.formLineTypeAccount.get(`specificSub${lineIndex}`).value : "";
      account.requestType = this.data.isEdit ? this.data.requestType : this.formLineType.get('requestType').value;
      account.lineType = this.data.lineType;
      account.enteredByEmail = this.data.isEdit ? this.formLineType.get('enteredByEmail').value : this.user.userEmail;
      account.enteredByName = this.data.isEdit ? this.formLineType.get('enteredByName').value : this.user.userName;
      account.dateEntered = this.data.isEdit ? new Date(this.formLineType.get('dateEntered').value) : new Date();
      account.updatedByName = this.user.userName;
      account.dateUpdated = new Date();
      account.updatedByEmail = this.user.userEmail;
      account.entryType = "S"; 
      const line = lineIndex;      
      this.specificAccounts[index] = { ...account, mcu, obj, sub, line};
    });
    return [this.allAccount, this.afeAccount, this.opexAccount, ...this.specificAccounts];
  }


  startAction(){
    if (this.formLineType.invalid) {
      this.formLineType.markAllAsTouched();
      this.validationMessage = 'Please fill all required fields.';
      return;
    }
    if(this.data.isEdit){      
      this.requestAndLineTypeService.updateLineType(this.getManageLineTypeAccountValues()).subscribe({
        next: (result) => {
          if (result.isSuccess) {
            this.information = "Line Type Updated";
          } else {
            this.information = result.error.description;
          }
        },
        error: (err) => {
          console.error('Error updating Line Type:', err);
          this.information = 'An error occurred while updating the Line Type.';
        }
      });

    }
    else{
      this.requestAndLineTypeService.addLineType(this.getManageLineTypeAccountValues()).subscribe({
        next: (result) => {
          if (result.isSuccess) {
            this.information = "Line Type Added";
          } else {
            this.information = result.error.description;
          }
        },
        error: (err) => {
          console.error('Error adding Line Type:', err);
          this.information = 'An error occurred while adding the Line Type.';
        }
      });
    }
  } 

  tryDelete(){
    if(confirm("Confirm that you want to remove this line type.")) {
      this.delete();
    }
  }

  delete(){
    this.requestAndLineTypeService.deleteLineType(this.data.requestType, this.data.lineType).subscribe({
      next: (result) => {
        if (result.isSuccess) {
          this.information = "Line Type deleted";
        } else {
          this.information = result.error.description;
        }
      },
      error: (err) => {
        console.error('Error deteling Line Type:', err);
        this.information = 'An error occurred while deleting the Line Type.';
      }
    });
  }

  onPromptTypeSelect(event: any): void {
    this.formLineType.patchValue({ 
      promptText1: "",
      promptText2: "",
      promptText3: "", 
      rateDecimal: 0,
    });
    this.propmptTypeSelected = event;
  }

  checkIfAddNewSpecificAccount() {
    this.specificAccountsInfo= "";
    if(this.specificAccountsNumber == 0){
      this.addSpecificAddtitionalAccounts();
      return;
    }

    const cost = this.formLineTypeAccount.get(`specificCost${this.specificAccountsNumber}`).value;
    const obj = this.formLineTypeAccount.get(`specificObj${this.specificAccountsNumber}`).value;
    const sub = this.formLineTypeAccount.get(`specificSub${this.specificAccountsNumber}`).value;

    if(cost === '' && obj === '' && sub === ''){
      this.specificAccountsInfo = "Please fill the last specific account before adding a new one";
    }else{
      this.addSpecificAddtitionalAccounts();
      return;
    }
  }

  addSpecificAddtitionalAccounts(){ 
    this.specificAccountsNumber++;    
    this.specificAccounts.push(this.getDefaultObject('S'));

    this.specificAccounts.forEach((account, index) => {
      this.formLineTypeAccount.addControl(`specificCost${index + this.specificAccountsNumber}`, new FormControl(""));
      this.formLineTypeAccount.addControl(`specificObj${index + this.specificAccountsNumber}`, new FormControl(""));
      this.formLineTypeAccount.addControl(`specificSub${index + this.specificAccountsNumber}`, new FormControl(""));
      this.formLineTypeAccount.addControl(`line${index + this.specificAccountsNumber}`, new FormControl(""));
    });

    this.specificAccounts.forEach((account, index) => {
      this.formLineTypeAccount.patchValue({
      [`specificCost${index + this.specificAccountsNumber}`]: "",
      [`specificObj${index + this.specificAccountsNumber}`]: "",
      [`specificSub${index + this.specificAccountsNumber}`]: "",
      [`line${index + this.specificAccountsNumber}`]: index + this.specificAccountsNumber
      });
    })
  }  

  onRestCostChange(){
    this.isRestCostAdded = this.checkIfRestCostFieldHasValues();
  }

  checkIfRestCostFieldHasValues(): boolean{
    const controls = this.formLineTypeAccount.controls;
    const filteredControls = Object.keys(controls).filter(name => !name.includes('all') && !name.includes('line'));

    for (const name in controls) {
      if(!filteredControls.includes(name)){
        continue;
      }

      if (controls[name].value) {
        return true     
      }
    }
    return false 
  }

  onAllCostChange(){
    this.isAllCostAdded = this.checkIfAllCostFieldHasValues()
    
  }

  checkIfAllCostFieldHasValues(): boolean{
    const controls = this.formLineTypeAccount.controls;
    const filteredControls = Object.keys(controls).filter(name => name.includes('all') && !name.includes('line'));
    for (const name in controls) {
      if(!filteredControls.includes(name)){
        continue;
      }

      if (controls[name].value) {
        return true     
      }
    }
    return false 
  }

  close() {
    this.dialogRef.close();
  }   
}
